import React from 'react';
import {Checkbox} from 'antd';

import {FormFieldInputWrapperClasses, FormFieldWrapperClasses} from '../';
import {trb} from '../../../Utilities';

export const CheckboxFormField = (props) => {
    const title = props.title,
        titleWithoutTranslate = props.titleWithoutTranslate,
        className = props.className,
        classNameField = props.classNameField,
        classNameTitle = props.classNameTitle,
        classNameError = props.classNameError,
        inline = props.inline,
        disabled = props.disabled,
        label = props.label,
        translate = props.translate,
        checkedNumber = props.checkedNumber;;

    const meta = props.meta;

    return <div className={FormFieldWrapperClasses(className, inline)}>
        {title && <div className={
            classNameTitle
            ? 'form-field-title ' + classNameTitle
            : inline
                ? (className && className.indexOf('col-12') === -1) || (className && className.indexOf('col-12') !== -1 && className.indexOf('col-md-') !== -1)
                    ? 'form-field-title col-12 col-md-5 text-left text-md-right pb-2 pb-md-0 pr-md-0'
                    : 'form-field-title col-12 col-md-3 text-left text-md-right pb-2 pb-md-0'
                : 'form-field-title col-12'
        }>{titleWithoutTranslate ? title : trb(title)}</div>}
        <div className={
            classNameField
                ? 'form-field-item ' + classNameField
                : FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline, className)}>
            <Checkbox
                disabled={disabled}
                checked={checkedNumber ? props.input.value == 1 : !!props.input.value}
                onChange={props.input.onChange}
            >
                {translate ? trb(translate) : label}
            </Checkbox>
        </div>
        <div className={
            classNameError
                ? 'form-field-error ' + classNameError
                : inline ? 'form-field-error col-12 col-md-3' : 'form-field-error col-12'}>{meta.touched && (meta.error || meta.submitError)}</div>
    </div>
};
